import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import StarfieldCanvas from './StartFeildCanvas';

// import "@/styles/assessment.css";
import "./Assesment.css";
interface Props {
  setCurrentScreenId: (id: number) => void;
}


const StartAssesmnetPage = ({ setCurrentScreenId }: Props) => {
  const [passPercentage, setPassPercentage] = useState(80);
  const [landingTitle, setLandingTitle] = useState("First Time People Leader Certification");
  const [landingDescription, setLandingDescription] = useState(
    "Take this assessment to earn your certificate and unlock your personalised learner report. You must complete it in one sitting and score at least {passPercentage}% to become certified."
  );

  useEffect(() => {
    fetch("/questions.json")
      .then((r) => r.json())
      .then((data: any) => {
        if (data.passPercentage != null) setPassPercentage(data.passPercentage);
        if (data.landingTitle) setLandingTitle(data.landingTitle);
        if (data.landingDescription) setLandingDescription(data.landingDescription);
      })
      .catch(() => { });
  }, []);

  const resolvedDescription = landingDescription.replace(
    "{passPercentage}",
    String(passPercentage)
  );

  return (
    <div className="assess-page">
      <StarfieldCanvas />
      <div className="assess-scanlines" />
      <div
        style={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          padding: "24px",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: 520 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🎓</div>
          <h1
            className="assess-glitch"
            data-glitch={landingTitle}
            style={{
              fontSize: 26,
              fontWeight: 800,
              marginBottom: 10,
              background: "linear-gradient(135deg, #ffd700, #ffa500)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {landingTitle}
          </h1>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 24 }}>
            {resolvedDescription}
          </p>
        

          <button
            onClick={() => setCurrentScreenId(17)}
            className="assess-primary-btn"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "12px 28px",
              fontSize: 15,
              textDecoration: "none",
            }}

          >
            🎓 Start Assessment
          </button>

        </div>
      </div>
    </div>
  );
};

export default StartAssesmnetPage;
